"use strict";

var _slicedToArray = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/classCallCheck");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var notebooks_json_1 = __importDefault(require("../../fixtures/regexes/device/notebooks.json"));

var variable_replacement_1 = require("../../utils/variable-replacement");

var user_agent_1 = require("../../utils/user-agent");

var model_1 = require("../../utils/model");

var NotebooksParser = function NotebooksParser() {
  _classCallCheck(this, NotebooksParser);

  this.parse = function (userAgent) {
    var result = {
      type: "",
      brand: "",
      model: ""
    };

    if (!user_agent_1.userAgentParser("FBMD/", userAgent)) {
      return result;
    }

    for (var _i = 0, _Object$entries = Object.entries(notebooks_json_1.default); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          brand = _Object$entries$_i[0],
          notebook = _Object$entries$_i[1];

      var match = user_agent_1.userAgentParser(notebook.regex, userAgent);
      if (!match) continue;
      result.type = "desktop";
      result.brand = brand;

      if ("model" in notebook && notebook.model) {
        result.model = model_1.buildModel(variable_replacement_1.variableReplacement(notebook.model, match)).trim();
      } else if ("models" in notebook && notebook.models) {
        var _iterator = _createForOfIteratorHelper(notebook.models),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var model = _step.value;

            var _match = user_agent_1.userAgentParser(model.regex, userAgent);

            if (!_match) continue;
            result.model = variable_replacement_1.variableReplacement(model.model, _match).trim();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      break;
    }

    return result;
  };
};

exports.default = NotebooksParser;